
import { Component, Vue } from "vue-property-decorator";
import { TranslateMalay}  from "@/languages/translate_malay";
import { TranslateEn } from "@/languages/translate_en";

@Component
export default class Indinsight extends Vue {
   selectedLanguage: string='';

              redirectToJobseekerSignup(){
     this.$router.push("/individualSignup");
  }

    created()
{
this.selectedLanguage = localStorage.getItem("selectedlanguage");

}

}
